/**
 * API client constants
 *
 * Configuration values for API request handling.
 */

/**
 * HTTP methods that support idempotency keys
 */
export const IDEMPOTENT_METHODS = ['POST', 'PUT', 'PATCH', 'DELETE'] as const;

/**
 * Derived type for idempotent HTTP methods
 */
export type IdempotentMethod = (typeof IDEMPOTENT_METHODS)[number];

/**
 * Header prefixes that should be filtered from logs for security
 */
export const SENSITIVE_HEADER_PREFIXES = ['authorization', 'cookie'] as const;

/**
 * Derived type for sensitive header prefixes
 */
export type SensitiveHeaderPrefix = (typeof SENSITIVE_HEADER_PREFIXES)[number];
